<form (submit)="$event.preventDefault()">
  <label>
    {{ label() }}
    <input
      #filterInput
      type="text"
      (input)="filter()"
      (keydown)="filterInputKeyDown($event)"
    />
  </label>

  @if (players().length) {
    <ul #resultsList class="players">
      @for (player of players(); track player.id; let index = $index) {
        <li>
          <button
            type="button"
            [tabindex]="focusIndex() === index ? 0 : -1"
            (click)="clickOption(player.id)"
            (keydown)="optionKeyDown($event, index)"
          >
            <lib-player [player]="player" [linkEnabled]="false" />
          </button>
        </li>
      }
    </ul>
  }
</form>
